import {useRef} from "react";

const Collapse = ({isOpen, children}) => {
    const ref = useRef(null);
    const inlineStyle = isOpen ? {height: "auto"} : {height: 0};

    return (
        <div
            id="legend-header"
            ref={ref}
            style={inlineStyle}
            className={`transition-height ease mt-2 ${
                isOpen ? `overflow-initial` : `overflow-hidden hidden`
            } duration-300`}
        >
            {children}
        </div>
    );
};

export default Collapse;
